jQuery(document).ready(function ($) {
    $('.collapsible--expanded > .collapsible__content').show();

    $(document).on('click', '.js-collapse-list', function () {
        var $collapsible = $(this).parents('.product-forms').find('.collapsible');

        if ($collapsible.hasClass('collapsible--expanded')) {
            $(this).removeClass('collapsible--expanded');
            $collapsible.removeClass('collapsible--expanded').children('.collapsible__content').stop().slideUp(300);
        } else {
            $(this).addClass('collapsible--expanded');
            $collapsible.addClass('collapsible--expanded').children('.collapsible__content').stop().slideDown(300);
        }
    });

    var open = true;
    $(window).on("load resize",function(e){
        if(screen.width < 768 && open){
            $('.js-collapse-close-mobile').trigger('click');
            open = false;
        }
        if(screen.width > 767 && !open){
            $('.js-collapse-close-mobile').trigger('click');
            open = true;
        }
    });

});
